import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { useMediaQuery, Grid } from '@material-ui/core'
import Image from '../../../shared/Image'
import SectionHeader from '../../../shared/SectionHeader'
import blackManAnalytics from '../../../assets/images/illustrations/black_man_analytics.png'
import CustomButton from '../../../shared/CustomButton'
import dashboardBottomBanner from '../../../assets/images/illustrations/dashboard_bottom_banner.png'
import CustomTypography from '../../../shared/CustomTypography'
import TypedText from '../../../shared/TypedText'

const useStyles = makeStyles((theme) => ({
  root: {},
  image: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
  mainContainer: {
    maxWidth: 1366,
    width: '100%',
    margin: '0 auto',
    padding: '0 15px',
    [theme.breakpoints.down('1450')]: {
      maxWidth: 1200,
    },
    [theme.breakpoints.down('md')]: {
      padding: '0 40px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0 24px',
    },
  },
  sectionTitle: {
    '& h3': {
      fontSize: 60,
      fontWeight: 800,
      marginBottom: 15,
      padding: 0,
      [theme.breakpoints.down('1450')]: {
        fontSize: 48,
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: 10,
        marginTop: 24,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 28,
        marginBottom: 2,
      },
    },
    '& .section-header__subtitle': {
      maxWidth: 546,
      fontWeight: 300,
      color: '#1A1A1A',
      marginBottom: 25,

      [theme.breakpoints.down('md')]: {
        margin: '0 auto 15px',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
        padding: '0 12px',
        fontWeight: 400,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 17,
        padding: '0 0',
      },
    },
    '& .typed-text': {
      '& span': {
        fontWeight: 800,
        fontSize: 64,
        [theme.breakpoints.down('1450')]: {
          fontSize: 52,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 34,
        },
      },
    },
  },
  heroTextBox: {
    [theme.breakpoints.down('sm')]: {
      order: 2,
    },
  },
  heroImageBox: {
    [theme.breakpoints.down('sm')]: {
      order: 1,
    },
  },
  demoButton: {
    borderRadius: 5,
    maxWidth: 307,
    minWidth: 307,
    fontSize: 16,
    padding: '0',
    '& a': {
      color: '#ffffff',
      height: '100%',
      width: '100%',
      padding: '15px 20px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      minWidth: 200,
      padding: '0',
    },
  },
  dashboardBannerImage: {
    marginTop: '-180px',
    [theme.breakpoints.down('1366')]: {
      marginTop: 50,
    },
    [theme.breakpoints.down('960')]: {
      marginTop: 15,
    },
    '& img': {
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        transform: 'scale(1.5)',
        marginTop: 20,
      },
    },
  },
}))

const Hero = (props) => {
  const { className, ...rest } = props
  const classes = useStyles()
  const theme = useTheme()
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      <div className={classes.mainContainer}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={isMd ? 4 : 2}
        >
          <Grid
            item
            xs={12}
            md={6}
            className={classes.heroTextBox}
            data-aos="fade-up"
          >
            <SectionHeader
              className={classes.sectionTitle}
              title={
                <span>
                  <CustomTypography variant="h3">
                    <span className={classes.titleHeading}>
                      We make production
                    </span>
                    <br />
                    <TypedText
                      component="span"
                      variant="h3"
                      color="primary"
                      className={classes.titleHeading}
                      typedProps={{
                        strings: ['management', 'accounting', 'compliance'],
                        typeSpeed: 50,
                        loop: true,
                      }}
                    />
                    easier
                  </CustomTypography>
                </span>
              }
              subtitle="Cloud-based purchase order, payment request and file management system that allows production management and finance teams to work seamlessly."
              ctaGroup={[
                // <CustomButton
                //   variant="contained"
                //   color="primary"
                //   size="large"
                //   onClick={() => route('/login')}
                // >
                //   Login
                // </CustomButton>,
                // <CustomButton
                //   variant="outlined"
                //   color="primary"
                //   size="large"
                //   onClick={() => route('/')}
                // >
                //   Sign Up
                // </CustomButton>,
                <CustomButton
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.demoButton}
                >
                  <a
                    href="https://getgist.me/sh29229pn/schedule"
                    target="_blank"
                  >
                    {' '}
                    BOOK A DEMO{' '}
                  </a>
                </CustomButton>,
                <div id="myEle1"></div>,
                // eslint-disable-next-line prettier/prettier
              ]}
              align={isMd ? 'left' : 'center'}
              disableGutter
              titleVariant="h3"
            />
            <SectionHeader />
          </Grid>
          <Grid
            item
            container
            justifyContent="center"
            alignItems="center"
            xs={12}
            md={6}
            className={classes.heroImageBox}
            data-aos="fade-up"
          >
            <Image
              src={blackManAnalytics}
              alt="Conduiit"
              className={classes.image}
            />
          </Grid>
        </Grid>
      </div>
      <div className={classes.dashboardBannerImage}>
        <img src={dashboardBottomBanner} alt="Conduiit" />
      </div>
      <div className={clsx(classes.root, className)} {...rest}></div>
    </>
  )
}

Hero.propTypes = {
  className: PropTypes.string,
}

export default Hero
